export const AUTOSURE_BRANDED_SOURCES = ['TFAF_AUTOSURE', 'QUASHED', 'MONEYHUB', 'MYAUTOSHOP'];
